import React from 'react';

export interface PriceListCardProps {
  title: string;
  description: string;
  price: string;
  buttonText: string;
  buttonAction: () => void;
}

const PriceListCard: React.FC<PriceListCardProps> = ({
  title,
  description,
  price,
  buttonText,
  buttonAction,
}) => {
  return (
    <div className="flex w-full max-w-sm flex-col items-center justify-between space-y-4 rounded-2xl border border-gray-200 bg-white p-6 shadow-lg">
      <div className="flex flex-col items-center space-y-4">
        <h2 className="text-center text-xl font-semibold text-gray-800">{title}</h2>
        <p className="text-center text-gray-600">{description}</p>
        <div className="text-2xl font-bold text-gray-900">{price}</div>
      </div>
      <button
        onClick={buttonAction}
        className="w-full rounded-xl bg-blue-600 px-4 py-2 font-medium text-white shadow transition-colors hover:bg-blue-700"
      >
        {buttonText}
      </button>
    </div>
  );
};

export default PriceListCard;
